import { render, staticRenderFns } from "./ProductTop.vue?vue&type=template&id=4246f3ef&scoped=true&"
import script from "./ProductTop.vue?vue&type=script&lang=js&"
export * from "./ProductTop.vue?vue&type=script&lang=js&"
import style0 from "./ProductTop.vue?vue&type=style&index=0&id=4246f3ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246f3ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4246f3ef')) {
      api.createRecord('4246f3ef', component.options)
    } else {
      api.reload('4246f3ef', component.options)
    }
    module.hot.accept("./ProductTop.vue?vue&type=template&id=4246f3ef&scoped=true&", function () {
      api.rerender('4246f3ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductTop.vue"
export default component.exports